<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import messages from './locales/messages'
 
const cart = useCartStore()
const productStore = useProductStore()
const router = useRouter()

const { show_modal, last_added } = storeToRefs(cart)
const { t, locale } = useI18n({
    useScope: 'global',
    messages
})

const product = ref(null)
const article = ref(null)
const img_url = computed(()=>{
    if(product.value && product.value.images && product.value.images[0]){
        return `https:///assets.zokkus.com/images/format-128x128/${product.value.images[0].name}`
    }
    return '/img/no-picture.jpg';
})

const productName = computed(()=>{
    if(product.value && product.value.content && product.value.content[locale.value]){
        let title = product.value.content[locale.value].name
        if(product.value.articles.length == 1 && product.value.articles[0].name!=''){
            title += ` - ${product.value.articles[0].name}`
        }
        return title
    }
    return ''
})
const version = computed(()=>{
    if(product.value && product.value.articles.length>1){
        return t('cart.modal.product_version')+' : '+article.value.name
    }
    return ''
})

const articlePrice = computed(()=>{
    if(article.value){
        return article.value.prices.discount.toFixed(2).replace('.',',')
    }
    return 'N/A €'
})
const articlePriceOfficial = computed(()=>{
    if(article.value && article.value.prices.official > article.value.prices.discount){
        return article.value.prices.official.toFixed(2).replace('.',',')
    }
    return false
})

watch(last_added, (newVal)=>{
    if(newVal!=null){
        productStore.getProductById(newVal.product_id)
            .then((res)=>{
                product.value = res
                article.value = res.articles.find(a => a.id == newVal.article_id)
            })
            .catch((err)=>{
                product.value = null
                article.value = null
            })
    }
    else{
        product.value = null
        article.value = null
    }
})

function goToCart(){
    show_modal.value = false
    router.push({name: locale.value+'.cart'})
}

</script>
<template>
<div v-if="show_modal && product!=null && product!=undefined" class="modal_bkg">
    <div class="cart_modal">
        <div class="cart_modal_header">
            <h2>{{ $t('cart.modal.title') }}</h2>
        </div>
        <div class="cart_modal_body">
            <div class="d-flex">
                <img class="modal_product_img" :src="img_url" alt="product image">
                <div class="ml-2 d-flex flex-column justify-space-between" style="width: calc(100% - 100px)">
                    <div class="mb-1">
                        <h3>{{ productName }}</h3>
                        <h4 v-if="version!=''">{{ version }}</h4>
                    </div>
                    <div class="d-flex justify-space-between">
                        <div class="stock_status" :class="article.available ? 'available' : 'unavailable'">{{article.available ? $t('product.available') : $t('product.unavailable')}}</div>
                        <div class="article_price">
                                <span v-if="articlePriceOfficial" class="official_price">{{articlePriceOfficial}} €</span>
                                <span>{{articlePrice}} €</span>
                            </div>
                    </div>
                </div>
            </div>
            <p v-if="product && product.articles.length>1" class="multiple_version">{{ $t('cart.modal.check_version') }}</p>
        </div>
        <div class="cart_modal_footer">
            <ZButton color="primary" @click="show_modal = false">{{ $t('cart.modal.continue_shopping') }} <v-icon>mdi-arrow-right-bold-outline</v-icon></ZButton>
            <ZButton color="primary" @click="goToCart">{{ $t('cart.modal.checkout') }} <v-icon>mdi-cart-outline</v-icon></ZButton>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>
.modal_bkg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 4000;
    display: flex;
    justify-content: center;
    align-items: center;
    .cart_modal{
        background-color: #FFF;
        border-radius: 16px;
        padding: 20px;
        width: 90%;
        max-width: 800px;
        box-shadow: 0 0 15px rgba(0,0,0,0.8);
        .cart_modal_header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            h2{
                margin: 0 0 10px 0;
                font-size: 18px;
            }
            button{
                background-color: #E91B1B;
                color: #FFF;
                border: none;
                border-radius: 8px;
                padding: 5px 10px;
                cursor: pointer;
            }
        }
        .cart_modal_body{
            img.modal_product_img{
                box-shadow: 0px 0px 4px 0px #00000040;
                width: 100px;
                height: 100px;
            }
            h3{
                font-size: 16px;
            }
            h4{
                
                font-size: 14px;
            }
            .stock_status{
                font-family: Montserrat;
                font-weight: 700;
                font-size: 14px;
                letter-spacing: 0%;
                &.available{
                    color: #5ED880;
                }
                &.unavailable{
                    color: #FF0000;
                }
            }
            .article_price{
                font-family: Montserrat;
                font-weight: 700;
                font-size: 18px;
                line-height: 21.94px;
                letter-spacing: 0%;
                .official_price{
                    text-decoration: line-through;
                    //color: #cd1616;
                    margin-right: 10px;
                    font-weight: 500;

                }
            }
            .multiple_version{
                font-family: Montserrat;
                font-weight: 400;
                font-size: 13px;
                line-height: 17.07px;
                letter-spacing: 0%;
                text-align: justify;
                padding: 10px 10px;
                color: #000000;
                margin-top: 15px;
                margin-bottom: 5px;
                background-color: #FFE5B4;
                border: 1px solid #FFA500;
                border-radius: 10px;
            }
        }
        .cart_modal_footer{
            display: flex;
            flex-direction: column;
            
        }
    }
}

</style>